<template>
  <view class="navbarBg">
    <es-navbar left-arrow="{{true}}" title="密码找回"> </es-navbar>
  </view>
  <view class="goPageBack" bindtap="goBack"></view>
  <view class="backgroundStyleBox">
    <view class="backgroundStyle">
      <view class="es-background-card">
        <view class="inputContainerStyle">
          <view class="messageStyle"> 证件类型 </view>
          <view class="es-input-style">
            <!-- <input
              type="text"
              class="inputStyle"
              placeholder="请选择证件类型"
              wx:model="{{idType}}"
              maxlength="26"
            /> -->
            <view class="inputStyle">
              {{ certificateType }}
            </view>
          </view>
          <view class="es-next-box" bindtap="handleNext">
            <es-icon name="angle-right" size="20" />
          </view>
        </view>
        <view class="inputContainerStyle">
          <view class="messageStyle"> 证件号码 </view>
          <view class="es-input-id-number">
            <input
              wx:style="width: 100%"
              type="{{cardType}}"
              class="inputStyle"
              placeholder="请输入证件号码"
              wx:model="{{idNumber}}"
              maxlength="{{maxLeng}}"
              bindblur="inputCheckBlur"
            />
            <view class="es-retrieval-error" wx:class="{{idNumberComputed}}"
              >请填写正确的证件号码</view
            >
          </view>
        </view>
        <view class="inputContainerStyle">
          <view class="messageStyle"> 姓名 </view>
          <view class="es-input-style es-input-style-bottom">
            <input type="text" class="inputStyle" placeholder="请输入真实姓名" wx:model="{{idName}}"
          /></view>
        </view>
        <!-- <es-button type="info" round size="large" bind:click="goPage('list')"
        >跳转到下一个页面</es-button
      > -->
        <!-- {{ currentIndex }} -->
        <drawer-bottom
          show="{{ show }}"
          bindclose="closeDialog"
          title="请选择证件类型"
          showDefaultNav="{{true}}"
        >
          <view class="es-travel-container">
            <view
              class="es-travel-list"
              wx:for="{{list}}"
              bindtap="changeItem"
              data-code="{{item.code}}"
              data-name="{{item.name}}"
              wx:key="{{item.code}}"
            >
              <text> {{ item.name }}</text>
              <es-icon
                class="es-mark"
                wx:if="{{currentIndex == item.code}}"
                name="check"
                size="20"
              ></es-icon>
            </view>
          </view>
        </drawer-bottom>
      </view>
    </view>
    <view class="es-next-step">
      <!-- <view class="buttonStyle" wx:class="{{actives}}" bindtap="onClick">下一步</view> -->
      <view class="buttonStyle" bindtap="onClickNext">下一步</view>
    </view>
  </view>
</template>


<script>
  import { createPage, mpx } from '@didi/es-mpx-creator'
  import { idTypeList } from '@/api/id-type-list'
  import store from '@/store'
  import { LOAD_FAIL_CONTENT } from '@/common/constant'
  import { innerRouter, pagePath } from "@/common/jump";
  import { permitValidateConf } from '@/utils'
  createPage({
    data: {
      idType: '', // 证件类型
      idNumber: '', // 证件号码
      idName: '', // 证件名称
      isShowDialog: false,
      activeHover: true,
      idNumberHover: true,
      show: false,
      list: [],
      currentIndex: ''
    },
    computed: {
      ...store.mapState({}),
      cardType() {
        const type = Number(this.currentIndex)
        let typeString = 'text' // "text"
        if (typeof type === 'number' && !isNaN(type)) {
          typeString = 'idCard'
        }

        return typeString
      },
      maxLeng() {
        const type = Number(this.currentIndex)
        let len = 26 // "text"
        if (typeof type === 'number' && !isNaN(type)) {
          len = 18
        }
        return len
      },
      certificateType() {
        const text = this.idType.length ? this.idType : '请选择证件类型'
        return text
      },
      actives() {
        const { activeHover } = this
        if (this.idType.length && this.idNumber.length && this.idName.length) {
          this.activeHover = false
          return {
            'button-not-active': false
          }
        } else {
          this.activeHover = true
          return {
            'button-not-active': true
          }
        }
      },
      idNumberComputed() {
        return {
          'not-hover': this.idNumberHover
        }
      }
    },
    watch: {
      currentIndex: {
        handler(val, old) {
          // 每次切换证件 自动清空证件号码
          this.idNumber = ''
          this.idNumberHover = true
          // this.inputCheckBlur()
        }
      }
    },
    methods: {
      ...store.mapMutations({
        accountInfo12306: 'login12306.accountInfo12306'
      }),
      goBack() {
        // innerRouter.goback();
        if (__mpx_mode__ !== 'web') {
          innerRouter.goback()
        } else {
          // 兼容新处理 ，UC游览器下莫名其妙返回到首页
          const ua = navigator.userAgent.toLowerCase()
          const isUc = ua.indexOf('ucbrowser') > -1
          const isIphone = ua.indexOf('iphone') > -1
          if (isUc && isIphone) {
            innerRouter.push(pagePath().LOGIN12306,{ucbrowser})
          } else {
            innerRouter.goback()
          }
        }
        return false
      },
      handleNext() {
        this.show = true
      },
      showTravelQuota() {
        this.isShowDialog = true
      },
      inputCheckBlur() {
        if (this.idNumber.trim().length) {
          // 相对应证件的正则校验规则
          const validateConf = permitValidateConf({ code : this.currentIndex })
          const result = new RegExp(validateConf).test(this.idNumber)
          this.idNumberHover = result
          return result
        } else {
          mpx.showToast({
            title: '请填入证件号码', //提示的内容,
            icon: 'error', //图标,
            duration: 2000, //延迟时间,
            mask: true, //显示透明蒙层，防止触摸穿透,
            success: (res) => {}
          })
          this.idNumberHover = false
          return false
        }
      },
      closeDialog() {
        this.show = false
      },
      onClickNext() {
        const isTesting = this.inputCheckBlur()
        if (!isTesting) {
          return false
        }

        if (this.idNumber.length) {
          this.activeHover = false
        } else {
          this.activeHover = true
        }

        if (this.idName.trim().length === 0) {
          mpx.showToast({
            title: '请填入姓名', //提示的内容,
            icon: 'error', //图标,
            duration: 2000, //延迟时间,
            mask: true, //显示透明蒙层，防止触摸穿透,
            success: (res) => {}
          })
          return false
        }
        this.accountInfo12306({
          id_no: this.idNumber,
          id_type: this.currentIndex
        })
        if (!this.activeHover) {
          innerRouter.push(pagePath().PASSWORDMODIFICATION)
        }
      },
      changeItem(e) {
        this.currentIndex = e.currentTarget.dataset.code
        this.idType = e.currentTarget.dataset.name
        this.show = false
      }
    },
    mounted() {
      mpx.showLoading()
      idTypeList().then(({ data, code, success, message }) => {
        mpx.hideLoading()
        if (success) {
          if (code === '0' && data?.list) {
            const { list } = data
            this.list = list
            this.idType = list.find((value) => value.code === '1').name // 默认显示二代身份证
            this.currentIndex = list.find((value) => value.code === '1').code
          } else {
            mpx.showToast({
              title: message, //提示的内容,
              icon: 'error', //图标,
              duration: 2000 //延迟时间,
            })
          }
        } else {
          mpx.showToast({
            title: LOAD_FAIL_CONTENT, //提示的内容,
            icon: 'error', //图标,
            duration: 2000 //延迟时间,
          })
        }
      })
    }
  })
</script>

<style lang='stylus' scoped>
  @import '~@/mixins/stylus/color.styl'
  .navbarBg
    background-color $train-color-fff

  .goPageBack
    position absolute
    left 0px
    top 2px
    z-index 999
    width 100%
    height 60px
    // background #000000
  .es-content-hover
    color $train-color-background
  .es-background-card
    background #ffffff
    border-radius 8px
    padding 5px 0px 0px 5px
  .tab-label
    padding 0 5px
    position absolute
    font-size 10px
    height 18px
    line-height 18px
    color #ffffff
    background #FD6C19
    border-radius 9px
    border 1px solid #FFFFFF
  .backgroundStyleBox
    display flex
    flex-direction column
    justify-content space-between
    box-sizing border-box
    background-color $train-color-background
    height 90%
  .backgroundStyle
    padding 12px
    background-color $train-color-background
  .title
    margin-left 10px
    padding 10 20
    color black
    font-size 20px
    text-align center
    background #FD6C19
    border 1px solid #ffffff
    width 250px
    height 25px
  .titleStyle
    padding-top 0
    padding-bottom 12px
    color #000000
    font-size 16px
  .titleStyles
    padding-top 24px
    padding-bottom 12px
    color #000000
    font-size 16px
  .contentStyle
    color $train-color-666
    font-size 14px
  .messageStyle
    color $train-color-333
    font-size 15px
    display inline-block
    width 70px
  .messageBorder
    color #C0C0C0
    padding 0 10px
  .buttonStyle
    margin-top 16px
    color #ffffff
    background $train-color-theme-blue
    font-size 16px
    border-color $train-color-theme-blue
    padding 10px 10px
    text-align center
    border-radius 8px
  .search
    color $train-color-divider-ccc
    font-size 15px
    height 44px
    padding 13px
    width 100%
    outline none
    box-sizing border-box
  .inputContainerStyle
    padding 10px
    display flex
    align-items center
    width 100%
    box-sizing border-box
    position relative
    height 55px
  .inputStyle
    font-size 15px
    color $train-color-666
    height 21px
    outline none
  .inputStyle::placeholder
    color $train-color-999
  .button-not-active
    background $train-color-divider-ccc
  .es-next-step
    height 90px
    background #ffffff
    padding 0px 16px
  .es-next-box
    width 100%
    height 25px
    position absolute
    right 5px
    top 15px
    color $train-color-666
    display flex
    justify-content flex-end
    align-items center
  .es-input-id-number
    position relative
    width 255px
    height 21px
  .es-input-id-number:after
    content ' '
    display block
    width 100%
    height 1px
    background RGB(240, 241, 244)
    position absolute
    left 0
    top 38px
    z-index 1
  .es-retrieval-error
    color #f53f3f
    position absolute
    left 0px
    top 20px
    font-size 13px
    width 100%
    border-bottom 1px red solid
    z-index 2
  .not-hover
    display none
  .es-travel-container
    padding 0px 12px 12px 12px
    background #ffffff
    height 300px
    overflow-y auto
  .es-travel-list
    border-bottom 1px #EEEEEE solid
    padding 15px 0px
    background #ffffff
    display flex
    justify-content space-between
  .es-input-style
    width 255px
    position relative
  .es-input-style:after
    content ' '
    display block
    width 100%
    height 1px
    background RGB(240, 241, 244)
    position absolute
    left 0
    top 40px
  .es-input-style-bottom:after
    display none
  .es-mark
    color $train-color-theme-blue
</style>

<script name='json'>
  module.exports = {
    component: true,
    // navigationBarTitleText: '短信核验',
    usingComponents: {
      'es-button': '@didi/es-mpx-ui/lib/button',
      'es-dialog': '@didi/es-mpx-ui/lib/dialog',
      'drawer-bottom': '@didi/es-mpx-ui/lib/drawer-bottom',
      'es-icon': '@didi/es-mpx-ui/lib/icon'
    }
  }
</script>